import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import api, { formatApiError } from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { authenticate } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/auth", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        window.history.replaceState(null, "", window.location.pathname);
        authenticate(data.token, data.user);
        navigate("/", { replace: true });
      } catch (err) {
        setError(formatApiError(err.response?.data?.detail) || "Google sign-in failed");
        setTimeout(() => navigate("/auth", { replace: true }), 2500);
      }
    })();
  }, [authenticate, navigate]);

  return (
    <div className="min-h-screen cosmic-bg flex flex-col items-center justify-center gap-4">
      <Loader2 className="h-8 w-8 animate-spin" style={{ color: "#D4AF37" }} />
      <p className="text-white/60 text-sm">
        {error || "Aligning your stars..."}
      </p>
    </div>
  );
}
